import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import type { Dashboard } from "@lib/types/dashboards";
import {
  createDashboardWithUpdatedLayouts,
  invalidateDashboardQueries,
  type UpdateDashboardLayoutsInput,
  updateDashboardOnServer,
} from "./utils";

export function useUpdateDashboardLayouts() {
  const queryClient = useQueryClient();
  const { selectedOrganisation } = useSelectedStores();

  return useMutation({
    mutationFn: async ({
      dashboard,
      layouts,
    }: {
      dashboard: Dashboard;
      layouts: UpdateDashboardLayoutsInput;
    }) => {
      if (!selectedOrganisation) {
        throw new Error("Organisation ID is required");
      }

      return updateDashboardOnServer(
        selectedOrganisation,
        dashboard.id,
        createDashboardWithUpdatedLayouts(dashboard, layouts)
      );
    },
    onSuccess: async (updatedDashboard) => {
      await invalidateDashboardQueries(
        queryClient,
        selectedOrganisation,
        updatedDashboard.id
      );
    },
  });
}
